module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("CONTENTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-author"
  }, [_vm._v("D.P. Benjamin")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Princess And The Others")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Sailor’s Star")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Comet And The Pole Star")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("4. ")]), _c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Old Sol’s Menagerie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("5. ")]), _c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Major")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("6. ")]), _c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Bee Baby")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("7. ")]), _c('a', {
    attrs: {
      "href": "#/chapter007"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Lady Moon’s Lantern")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("8. ")]), _c('a', {
    attrs: {
      "href": "#/chapter008"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Andromeda’s Birthday")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("9. ")]), _c('a', {
    attrs: {
      "href": "#/chapter009"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("A Surprise Party")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("10. ")]), _c('a', {
    attrs: {
      "href": "#/chapter010"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Travelers’ Tales")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("11. ")]), _c('a', {
    attrs: {
      "href": "#/chapter011"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Torquillon’s Lair")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-part"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/upart001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("First Edition Artwork")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/upart001chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("First Edition Cover")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/upart001chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Drop Caps")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/publishersnote"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Publisher’s Note")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheauthor"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheillustrator"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About the Illustrator")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheforewordauthor"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About The Foreword Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheeditor"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About the Editor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/wordfireclassics"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("WordFire Classics")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0